import React from "react"
import DynamicSelector from "../../Molecules/DynamicSelector"
import { VARIETIES } from "graphql/selector.queries.gql"
import { Text } from "@blueprintjs/core"

const VarietySelector = ({ className = undefined, ...otherProps }) => {
  return (
    <DynamicSelector
      formGroupProps={{
        className,
      }}
      searchVector={["name", "commodity.name"]}
      query={VARIETIES}
      variables={{ includeCommodity: true }}
      // path="variety"
      // label="Variety"
      labelElement="commodity.name"
      renderText={selectedItem => {
        if (selectedItem?.name) {
          const { name, commodity } = selectedItem

          return <Text ellipsize={true}>{`${commodity.name} | ${name}`}</Text>
        } else {
          return "Select"
        }
      }}
      {...otherProps}
    />
  )
}

export default VarietySelector
